import React, { useEffect, useState } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { fetchUser } from 'Api/employeeAsess';

const useUser = userId => {
  const [user, setUser] = useState({});
  const { t2 } = useTranslation('Generic');

  useEffect(() => {
    fetchUser({ id: userId, t2 }).then(data => {
      setUser(data);
    });
  }, [userId]);

  return {
    user,
  };
};

export default useUser;
